export default __webpack_public_path__ + "static/media/Belt of Vengeful Zeal.58d6a65b.jpg";